/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoFileListRequest model module.
 * @module model/SystemControllerDtoFileListRequest
 * @version 1.0
 */
class SystemControllerDtoFileListRequest {
    /**
     * Constructs a new <code>SystemControllerDtoFileListRequest</code>.
     * @alias module:model/SystemControllerDtoFileListRequest
     */
    constructor() { 
        
        SystemControllerDtoFileListRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoFileListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoFileListRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoFileListRequest} The populated <code>SystemControllerDtoFileListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoFileListRequest();

            if (data.hasOwnProperty('container')) {
                obj['container'] = ApiClient.convertToType(data['container'], 'Number');
            }
            if (data.hasOwnProperty('folderName')) {
                obj['folderName'] = ApiClient.convertToType(data['folderName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoFileListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoFileListRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['folderName'] && !(typeof data['folderName'] === 'string' || data['folderName'] instanceof String)) {
            throw new Error("Expected the field `folderName` to be a primitive type in the JSON string but got " + data['folderName']);
        }

        return true;
    }


}



/**
 * @member {Number} container
 */
SystemControllerDtoFileListRequest.prototype['container'] = undefined;

/**
 * @member {String} folderName
 */
SystemControllerDtoFileListRequest.prototype['folderName'] = undefined;






export default SystemControllerDtoFileListRequest;

